/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_BlockingInputs */

const cs_portals_check_blocking = /** @type {(inputs: Portals_Check_BlockingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export není možný`)
};

const en_portals_check_blocking = /** @type {(inputs: Portals_Check_BlockingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export is not possible`)
};

/**
* | output |
* | --- |
* | "Export is not possible" |
*
* @param {Portals_Check_BlockingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_blocking = /** @type {((inputs?: Portals_Check_BlockingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_BlockingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_blocking(inputs)
	return cs_portals_check_blocking(inputs)
});